import {EventData} from '@/types/event';

export const isUserEventParticipant = (
  event: EventData | null,
  userId: string
): boolean => {
  if (event) {
    return event.participants.some((p) => p._id === userId);
  }
  return false;
};
